<template>
  <div class="wrapper">
    <v-icon v-if="icon" small class="icon">{{ icon }}</v-icon>
    <div v-if="tooltipText" class="container">
      <template>
        <div class="label" :style="color ? `color:${color}` : ''">
          {{ label }}
          &nbsp;
          <span v-if="tooltipIcon">
            <NumeraiTooltip float :text="tooltipText">
              <v-icon small class="tooltipIcon">{{ tooltipIcon }}</v-icon>
            </NumeraiTooltip>
          </span>
        </div>
        <div class="value" :style="color ? `color:${color}` : ''">
          <NumeraiTooltip float :text="tooltipText">
            <slot></slot>
          </NumeraiTooltip>
        </div>
      </template>
    </div>
    <div v-else class="container">
      <template>
        <div class="label" :style="color ? `color:${color}` : ''">
          {{ label }}
        </div>
        <div class="value" :style="color ? `color:${color}` : ''">
          <slot></slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import NumeraiTooltip from '@/components/shared/NumeraiTooltip'

export default {
  components: {
    NumeraiTooltip,
  },
  props: {
    color: { type: String, default: '' },
    label: { type: String, default: '' },
    value: { type: String, default: '' },
    icon: { type: String, default: '' },
    tooltipIcon: { type: String, default: '' },
    tooltipText: { type: String, default: '' },
  },
}
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--color-secondary);
  margin: 0;
  padding: 0;
}

.label {
  font-family: var(--ui-font);
}

.icon {
  margin-right: 6px;
  margin-top: 0.1em;
  color: var(--color-secondary);
}

.tooltipIcon {
  color: var(--color-text-negative);
}

.value {
  color: var(--color-secondary);
  font-weight: 500;
  font-family: var(--number-font);
  font-size: 0.9em;
}

.wrapper {
  display: flex;
  align-items: flex-start;
  margin: 0 0 0.4em 0;
  padding: 0.2em 0;
}
</style>
